import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TestPackData } from "src/app/exponent/bmsipqc/bmsipqc.component";
type batteryType = "piccolo" | "tg";

interface DialogueData {
  test_id: string;
  date: string;
  pack_data: TestPackData;
  metaData: {
    [key: string]: string | number;
  };
  metaDataByGroup: {
    [key: string]: { [key: string]: string }[];
  };
  battery_type: batteryType;
}

interface HeaderData {
  "Pack Id": string;
  "Test ID": string;
  Date: string;
  "BMS ID": string;
  "Product ID": string;
  "Variant ID": string;
  "SOP Flash": string;
  "Test Type": string;
}

@Component({
  selector: "app-metadata-dialouge",
  templateUrl: "./metadata-dialouge.component.html",
  styleUrls: ["./metadata-dialouge.component.css"],
})
export class IPQCMetadataDialougeComponent implements OnInit, AfterViewInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogueData,
    private dialogueRef: MatDialogRef<IPQCMetadataDialougeComponent>
  ) {}

  @ViewChild("dialogueHeader") dialogueHeader: ElementRef<HTMLDivElement>;
  @ViewChild("dialogueData") dialogueDataRef: ElementRef<HTMLDivElement>;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // this.generateMetaData(this.data.metaData);
    this.generateHeaderData({
      date: this.data.date,
      test_id: this.data.test_id,
      packData: this.data.pack_data,
    });
    const metaDataContainer = this.dialogueDataRef.nativeElement;
    generateGroupBasedMetaData(
      this.data.metaData,
      this.data.battery_type,
      metaDataContainer
    );
    this.setDialougeMetadataStyle(metaDataContainer);
  }

  private setDialougeMetadataStyle(hostElement: HTMLDivElement) {
    hostElement
      .querySelectorAll(".group-header")
      .forEach((header: HTMLElement) => {
        header.setAttribute(
          "style",
          `
            background-color: #cfcfcf;
            padding: 0.2rem;
            font-size: 1rem;
            margin: 0px;
            border-bottom: 1px solid #b5b5b5;
            text-align: center;
            font-weight: 500;
            padding: 0.5rem;
          `
        );
      });

    hostElement
      .querySelectorAll(".group-data-container")
      .forEach((dataContainer: HTMLElement) => {
        dataContainer.setAttribute(
          "style",
          `
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 0.5rem;
            background-color: #F1F1F1; 
            padding: 0.5rem; 
          `
        );
      });

    hostElement
      .querySelectorAll(".data-container")
      .forEach((dataContainer: HTMLDivElement) => {
        dataContainer.setAttribute(
          "style",
          `border: 1.2px solid #A3A3A3; background-color: rgb(199, 199, 199); text-align: center; font-size: 15px;`
        );

        const dataKey =
          dataContainer.querySelector<HTMLParagraphElement>(".data-key");
        const dataValue =
          dataContainer.querySelector<HTMLParagraphElement>(".data-value");

        dataKey.setAttribute(
          "style",
          `font-weight: 400; margin: 0px; padding: 0.5rem; `
        );

        dataValue.setAttribute(
          "style",
          ` font-weight: 500; margin: 0px; padding: 0.5rem; background-color: rgb(241, 241, 241); text-transform: capitalize;`
        );

        if (dataValue.textContent.trim().toLowerCase() === "fail") {
          dataContainer.style.border = "1.2px solid #b90000";
          dataContainer.style.backgroundColor = "#ff2f3640";
          dataKey.style.color = "#b90000";
          dataValue.style.color = "#b90000";
        }
      });
  }

  generateHeaderData(args: {
    packData: TestPackData;
    test_id: string;
    date: string;
  }) {
    if (!args.packData) {
      const fallbackData = {
        "Test ID": args.test_id,
        Date: args.date,
      };

      Object.entries(fallbackData).forEach(([key, value]) => {
        const dataContianer = document.createElement("p");
        const dataKey = document.createElement("b");
        const dataValue = document.createElement("span");

        dataKey.textContent = key + ": ";
        dataValue.textContent = String(value);

        dataContianer.appendChild(dataKey);
        dataContianer.appendChild(dataValue);

        dataContianer.style.margin = "0";

        this.dialogueHeader.nativeElement.appendChild(dataContianer);
      });

      return;
    }

    const {
      date,
      test_id,
      packData: {
        bms_id,
        pack_id,
        product_id,
        sop_flash,
        test_type,
        variant_id,
      },
    } = args;

    const headerData: HeaderData = {
      "Test ID": test_id,
      Date: date,
      "Pack Id": pack_id,
      "BMS ID": bms_id,
      "Product ID": product_id,
      "Variant ID": variant_id,
      "Test Type": test_type,
      "SOP Flash": sop_flash,
    };

    const headerDataKeys = Object.keys(headerData);

    headerDataKeys.forEach((key) => {
      const dataContianer = document.createElement("p");
      const dataKey = document.createElement("b");
      const dataValue = document.createElement("span");

      dataKey.textContent = key + ": ";
      dataValue.textContent = headerData[key] ?? "---";

      dataContianer.appendChild(dataKey);
      dataContianer.appendChild(dataValue);

      dataContianer.style.margin = "0";

      this.dialogueHeader.nativeElement.appendChild(dataContianer);
    });
  }

  generateMetaData(metaData: { [key: string]: string | number }) {
    Object.entries(metaData).forEach(([key, value]) => {
      const dataContianer = document.createElement("div");
      const dataKey = document.createElement("p");
      const dataValue = document.createElement("p");

      dataKey.innerText = key;
      dataValue.innerText = String(value);

      dataValue.style.fontWeight = "500";
      dataValue.style.margin = "0";
      dataValue.style.padding = "0.5rem";
      dataValue.style.backgroundColor = "rgb(241, 241, 241)";

      dataKey.style.fontWeight = "400";
      dataKey.style.margin = "0";
      dataKey.style.padding = "0.5rem";

      if (value.toString().toLowerCase().trim() === "fail") {
        dataContianer.style.border = "1.2px solid #b90000";
        dataContianer.style.backgroundColor = "#ff2f3640";

        dataKey.style.color = "#b90000";
        dataValue.style.color = "#b90000";
      } else {
        dataContianer.style.border = "1.2px solid rgba(163, 163, 163, 0.565)";
        dataContianer.style.backgroundColor = "rgb(199, 199, 199)";
      }

      dataContianer.style.textAlign = "center";
      dataContianer.style.fontSize = "15px";

      dataContianer.appendChild(dataKey);
      dataContianer.appendChild(dataValue);

      this.dialogueDataRef.nativeElement.appendChild(dataContianer);
    });
  }

  onDialogueClose() {
    this.dialogueRef.close();
  }
}

const getPiccoloGroupBasedData = (data: { [key: string]: string | number }) => {
  const groupingData: {
    group: string;
    label: string;
  }[] = [
    {
      group: "Results",
      label: "kaunas_status",
    },
    {
      group: "Results",
      label: "gpio_all_status",
    },
    {
      group: "Results",
      label: "m_bms_can_bms_status",
    },
    {
      group: "Results",
      label: "m_bms_battery_state_bms_status",
    },
    {
      group: "Results",
      label: "m_bms_curr_sense_har_btry_status",
    },
    {
      group: "Results",
      label: "m_bms_discharge_bms_state_status",
    },
    {
      group: "Results",
      label: "m_bms_charge_bms_state_status",
    },
    {
      group: "Results",
      label: "m_bms_voltage_range_status",
    },
    {
      group: "Results",
      label: "m_bms_voltage_imbalance_status",
    },
    {
      group: "Results",
      label: "m_bms_temp_range_status",
    },
    {
      group: "Results",
      label: "m_bms_temp_imbalance_status",
    },
    {
      group: "Results",
      label: "m_bms_cp_continuity_status",
    },
    {
      group: "Results",
      label: "m_bms_pp_feedback_status",
    },
    {
      group: "Results",
      label: "m_bms_motor_enable_feedback_status",
    },
    {
      group: "Results",
      label: "m_bms_solenoid_retract_feedback_status",
    },
    {
      group: "Results",
      label: "m_bms_solenoid_feedback_status",
    },
    {
      group: "Results",
      label: "m_bms_curr_sense_har_feedback_status",
    },
    {
      group: "Results",
      label: "m_bms_discharge_precharge_status",
    },
    {
      group: "Results",
      label: "m_bms_discharge_contactor_voltchk_status",
    },
    {
      group: "Results",
      label: "m_bms_discharge_contactor_weld_status",
    },
    {
      group: "Results",
      label: "m_bms_discharge_path_health_status",
    },
    {
      group: "Results",
      label: "m_bms_charge_path_health_status",
    },
    {
      group: "Results",
      label: "m_bms_charge_precharge_status",
    },
    {
      group: "Results",
      label: "m_bms_charge_contactor_volt_status",
    },
    {
      group: "Results",
      label: "m_bms_charge_contactor_weld_status",
    },
    {
      group: "Results",
      label: "m_bms_eeprom_memory_status",
    },
    {
      group: "Results",
      label: "m_bms_btryKey_flash_verify_status",
    },
    {
      group: "Results",
      label: "m_bms_bmsKey_flash_verify_status",
    },
    {
      group: "Results",
      label: "m_bms_storing_metadata_val_status",
    },
    {
      group: "Results",
      label: "final_test_result",
    },
    // {
    //   group: "Results",
    //   label: "battery_pack_type",
    // },
    {
      group: "Test details",
      label: "kaunas_health_check_fb",
    },
    {
      group: "Test details",
      label: "kaunas_gpio_check_fb",
    },
    {
      group: "BMS CAN UP check",
      label: "m_bms_can_up_fb",
    },
    {
      group: "Idle State check",
      label: "m_bms_idle_battery_state",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_1",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_2",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_3",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_4",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_5",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_6",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_7",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_8",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_9",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_10",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_11",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_12",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_13",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_14",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_15",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_cell_voltage_16",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_min_cell_voltage",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_max_cell_voltage",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "m_bms_voltage_imbalance",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_ct1",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_ct2",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_ct3",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_ct4",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt1",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt2",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt3",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt4",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt5",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt6",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_pt7",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_min_cell_temp",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_max_cell_temp",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "m_bms_temperature_imbalance",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_cp_continuity_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_proximity_pilot_in_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_motor_enable_continuity_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_solenoid_retract_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_solenoid_actuate_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_current_sense_battery_state",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "m_bms_adc_current_mcu",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_ratio_1",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_ratio_2",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_ratio_3",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_4",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_5",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_6",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_1",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_2",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_precharge_3",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_battery_state",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_contactor_on_voltage",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_path_health_check",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_contactor_weld_check_voltage",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_hw_version_exp",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_1",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_2",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_3",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_4",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_5",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_6",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_Ratio_1",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_Ratio_2",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_Precharge_Ratio_3",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_battery_state",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_contactor_on_voltage",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_discharge_path_health_check",
    },
    {
      group: "Contactor & Path health",
      label: "m_bms_charge_contactor_weld_check_voltage",
    },
    {
      group: "EEPROM Memory write/read check & Unique ID Flashing",
      label: "m_bms_eeprom_batteryid_verification",
    },
    {
      group: "EEPROM Memory write/read check & Unique ID Flashing",
      label: "m_bms_battery_id_flash_readback",
    },
    {
      group: "EEPROM Memory write/read check & Unique ID Flashing",
      label: "m_bms_id_flash_readback",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_soc_user",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_soc_actual",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_sop",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_soh",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_charge_cycle_count",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_fw_version_exp",
    },
    // {
    //   group: "Extra Metadata",
    //   label: "m_bms_fw_version_exp",
    // },
    // {
    //   group: "Extra Metadata",
    //   label: "not in the PL Meta Data",
    // },
    {
      group: "Extra Metadata",
      label: "m_bms_pov",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_puv",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_coc",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_doc",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cot",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_dot",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cut",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_dut",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cso",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ib",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_tso",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_scf",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_roc",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_sc_coc",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_icp",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ccuv",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_sc_coc1",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ccov",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ib1",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_afe_tp",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cnot",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_doc1",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_rm",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_pvi",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_dci",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cci",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_coms",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cov_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cuv_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_pov_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_puv_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_coc_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_doc_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cot_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_dot_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cut_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_dut_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cso_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ib_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_tso_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_scf_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_roc_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_sc_coc_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_icp_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ccuv_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_sc_coc1_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ccov_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_ib1_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_afe_tp_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cnot_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_doc1_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_rm_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_pvi_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_dci_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_cci_flag",
    },
    {
      group: "Extra Metadata",
      label: "m_bms_coms_flag",
    },
  ].map((i) => ({
    group: i.group.trim(),
    label: i.label.trim().toLowerCase(),
  }));

  const trimmedData = Object.entries(data).map(([key, value]) => ({
    label: key.toLowerCase().trim(),
    value: String(value).toLowerCase().trim(),
  }));

  const uniqueHeaders = Array.from(new Set(groupingData.map((_) => _.group)));
  let dataByHeaders: { [key: string]: { [key: string]: string }[] } = {};

  uniqueHeaders.forEach((header) => {
    let currentHeaderData = [];
    const currentHeaderKeys = groupingData
      .filter((_) => _.group === header)
      .map((i) => i.label);

    currentHeaderKeys.forEach((key) => {
      const dataItem = trimmedData.find((_) => _.label === key)?.value;
      currentHeaderData.push({ [key]: dataItem ?? "NA" });
    });

    dataByHeaders[header] = currentHeaderData;
  });

  return dataByHeaders;
};

const getTgGroupBasedData = (data: { [key: string]: string | number }) => {
  const groupingData: {
    group: string;
    label: string;
  }[] = [
    { group: "Test details", label: "kaunas_health_check_fb" },
    { group: "Test details", label: "kaunas_gpio_check_fb" },
    { group: "BMS CAN UP check", label: "bms_can_up_fb" },
    { group: "Idle State check", label: "idle_battery_state_bms" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_1" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_2" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_3" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_4" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_5" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_6" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_7" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_8" },
    { group: "Voltage Range and Imbalance check", label: "voltage_cell_9" },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_10",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_11",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_12",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_13",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_14",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_15",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_cell_16",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "min_cell_voltage",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "max_cell_voltage",
    },
    {
      group: "Voltage Range and Imbalance check",
      label: "voltage_imbalance",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_1",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_2",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_3",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_4",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_5",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_6",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_7",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_8",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_9",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_10",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_11",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_12",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_13",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_14",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_15",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "thermistor_16",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "min_thermistor_temp",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "max_thermistor_temp",
    },
    {
      group: "Temperature Range and Imbalance check",
      label: "temperature_imbalance",
    },
    { group: "Continuity and Feedback Checks", label: "cp_continuity_fb" },
    {
      group: "Continuity and Feedback Checks",
      label: "proximity_pilot_in_bms_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "motor_enable_continuity_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "solenoid_retract_bms_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "solenoid_actuate_bms_fb",
    },
    {
      group: "Continuity and Feedback Checks",
      label: "current_sense_battery_state_bms",
    },
    { group: "Continuity and Feedback Checks", label: "adc_current_mcu" },
    { group: "Contactor & Path health", label: "discharge_precharge_1" },
    { group: "Contactor & Path health", label: "discharge_precharge_2" },
    { group: "Contactor & Path health", label: "discharge_precharge_3" },
    { group: "Contactor & Path health", label: "discharge_precharge_4" },
    { group: "Contactor & Path health", label: "discharge_precharge_5" },
    { group: "Contactor & Path health", label: "discharge_precharge_6" },
    {
      group: "Contactor & Path health",
      label: "discharge_precharge_ratio_1",
    },
    {
      group: "Contactor & Path health",
      label: "discharge_precharge_ratio_2",
    },
    {
      group: "Contactor & Path health",
      label: "discharge_precharge_ratio_3",
    },
    {
      group: "Contactor & Path health",
      label: "discharge_battery_state_bms",
    },
    {
      group: "Contactor & Path health",
      label: "discharge_contactor_on_voltage",
    },
    { group: "Contactor & Path health", label: "charge_path_health_check" },
    {
      group: "Contactor & Path health",
      label: "discharge_contactor_weld_check_voltage",
    },
    { group: "Contactor & Path health", label: "bms_hw_version_exp" },
    { group: "Contactor & Path health", label: "charge_precharge_1" },
    { group: "Contactor & Path health", label: "charge_precharge_2" },
    { group: "Contactor & Path health", label: "charge_precharge_3" },
    { group: "Contactor & Path health", label: "charge_precharge_4" },
    { group: "Contactor & Path health", label: "charge_precharge_5" },
    { group: "Contactor & Path health", label: "charge_precharge_6" },
    { group: "Contactor & Path health", label: "charge_precharge_ratio_1" },
    { group: "Contactor & Path health", label: "charge_precharge_ratio_2" },
    { group: "Contactor & Path health", label: "charge_precharge_ratio_3" },
    { group: "Contactor & Path health", label: "charge_battery_state_bms" },
    {
      group: "Contactor & Path health",
      label: "charge_contactor_on_voltage",
    },
    {
      group: "Contactor & Path health",
      label: "discharge_path_health_check",
    },
    {
      group: "Contactor & Path health",
      label: "charge_contactor_weld_check_voltage",
    },
    {
      group: "EEPROM Memory write/read check & Unique ID Flashing",
      label: "eeprom_batteryid_verification",
    },
    {
      group: "EEPROM Memory write/read check & Unique ID Flashing",
      label: "battery_id_flash_readback",
    },
    {
      group: "EEPROM Memory write/read check & Unique ID Flashing",
      label: "bms_id_flash_readback",
    },
    { group: "Extra Metadata", label: "soc_user" },
    { group: "Extra Metadata", label: "soc_actual" },
    { group: "Extra Metadata", label: "sop" },
    { group: "Extra Metadata", label: "soh" },
    { group: "Extra Metadata", label: "charge_cycle_count" },
    { group: "Extra Metadata", label: "firmware_version_bms" },
    { group: "Extra Metadata", label: "bms_fw_version_exp" },
    {
      group: "Extra Metadata",
      label: "cov_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "cuv_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "pov_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "puv_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "coc_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "doc_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "cot_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "dot_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "cut_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "dut_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "cso_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "ib_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "tso_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "scf_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "roc_bms_hist",
    },
    {
      group: "Extra Metadata",
      label: "sc_coc_bms_hist",
    },
    { group: "Results", label: "kaunas_status" },
    { group: "Results", label: "gpio_all_status" },
    { group: "Results", label: "can_bms_status" },
    { group: "Results", label: "battery_state_bms_status" },
    { group: "Results", label: "curr_sense_har_btry_status" },
    { group: "Results", label: "discharge_bms_state_status" },
    { group: "Results", label: "charge_bms_state_status" },
    { group: "Results", label: "voltage_range_status" },
    { group: "Results", label: "voltage_imbalance_status" },
    { group: "Results", label: "temp_range_status" },
    { group: "Results", label: "temp_imbalance_status" },
    { group: "Results", label: "cp_continuity_status" },
    { group: "Results", label: "pp_feedback_status" },
    { group: "Results", label: "motor_enable_feedback_status" },
    { group: "Results", label: "solenoid_retract_feedback_status" },
    { group: "Results", label: "solenoid_feedback_status" },
    { group: "Results", label: "curr_sense_har_feedback_status" },
    { group: "Results", label: "discharge_precharge_status" },
    { group: "Results", label: "discharge_contactor_voltchk_status" },
    { group: "Results", label: "discharge_contactor_weld_status" },
    { group: "Results", label: "discharge_path_health_status" },
    { group: "Results", label: "charge_path_health_status" },
    { group: "Results", label: "charge_precharge_status" },
    { group: "Results", label: "charge_contactor_volt_status" },
    { group: "Results", label: "charge_contactor_weld_status" },
    { group: "Results", label: "eeprom_memory_status" },
    { group: "Results", label: "btrykey_flash_verify_status" },
    { group: "Results", label: "bmskey_flash_verify_status" },
    { group: "Results", label: "storing_metadataval_status" },
    { group: "Results", label: "final_test_result" },
  ].map((i) => ({
    group: i.group.trim(),
    label: i.label.trim().toLowerCase(),
  }));

  const trimmedData = Object.entries(data).map(([key, value]) => ({
    label: key.toLowerCase().trim(),
    value: String(value).toLowerCase().trim(),
  }));

  const uniqueHeaders = Array.from(new Set(groupingData.map((_) => _.group)));
  let dataByHeaders: { [key: string]: { [key: string]: string }[] } = {};

  uniqueHeaders.forEach((header) => {
    let currentHeaderData = [];
    const currentHeaderKeys = groupingData
      .filter((_) => _.group === header)
      .map((i) => i.label);

    currentHeaderKeys.forEach((key) => {
      const dataItem = trimmedData.find((_) => _.label === key)?.value;
      currentHeaderData.push({ [key]: dataItem ?? "NA" });
    });

    dataByHeaders[header] = currentHeaderData;
  });

  return dataByHeaders;
};

export const generateGroupBasedMetaData = (
  metaData: { [key: string]: string | number },
  battery_type: batteryType,
  metaDataContainer: HTMLDivElement
) => {
  const data =
    battery_type === "piccolo"
      ? getPiccoloGroupBasedData(metaData)
      : getTgGroupBasedData(metaData);

  let groups = Object.keys(data);
  const groupContainerStyle = `
      border: 1px solid #a3a3a3
    `;

  let sortedGroups = [...groups].sort((a, b) => a.localeCompare(b));
  sortedGroups.splice(sortedGroups.indexOf("Results"), 1);
  sortedGroups.unshift("Results");

  sortedGroups.forEach((currentGroup) => {
    const groupContainer = document.createElement("div");
    const groupDataContainer = document.createElement("div");
    const groupHeader = document.createElement("h2");

    groupHeader.textContent = currentGroup;
    groupContainer.appendChild(groupHeader);
    groupContainer.appendChild(groupDataContainer);
    metaDataContainer.appendChild(groupContainer);

    const currentGroupData = data[currentGroup];

    currentGroupData.forEach((data) => {
      const dataContianer = document.createElement("div");
      const dataKey = document.createElement("p");
      const dataValue = document.createElement("p");
      const key = Object.keys(data)[0];
      const value = data[key];

      dataKey.innerText = key;
      dataValue.innerText = String(value);

      dataValue.classList.add("data-value");
      dataKey.classList.add("data-key");
      dataContianer.classList.add("data-container");

      dataContianer.appendChild(dataKey);
      dataContianer.appendChild(dataValue);
      groupDataContainer.appendChild(dataContianer);
    });

    groupContainer.setAttribute("style", groupContainerStyle);

    groupDataContainer.classList.add("group-data-container");
    groupContainer.classList.add("group-container");
    groupHeader.classList.add("group-header");
  });
};
